<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{ caption }}
        </template>
        <template slot="input">
            <div class="input-container">
                <switch-button inline @selected="selectNegation" v-model="negation" :options="negationOptions" />
                <inline-switch @selected="selectMode" v-model="conditionMode" :options="conditionModeOptions" />
                <template v-if="conditionMode == 'empty'">
                    <div class="inline-text">
                        N/A
                    </div>
                </template>
                <template v-else-if="conditionMode == 'radius'">
                    <input
                        v-model="pointValue.radiusValue"
                        :class="{ 'input-component': true, 'active': active }"
                        :disabled="disabled"
                        @input="handleInput"
                    />
                    <form-geo-input v-model="pointValue" disabled />
                </template>
            </div>
        </template>
    </form-input-layout>
</template>

<script>
import FormInputLayout from '../form/FormInputLayout';
import SwitchButton from '../button/SwitchButton';
import InlineSwitch from '../button/InlineSwitch';
import FormGeoInput from '../form/FormGeoInput';

export default {
    name: 'FilterInputGeoPoint',
    components: { InlineSwitch, SwitchButton, FormInputLayout, FormGeoInput },
    props: {
        helpItemCode: String,
        disabled: Boolean,
        caption: String,
        value: Object
    },
    data: function() {
        return {
            active: false,
            conditionMode: '',
            negation: '',
            pointValue: {
                longtitude: '',
                latitude: '',
                radiusValue: 0
            }
        };
    },
    computed: {
        negationOptions() {
            return [{ caption: this.$t("searchQuery.not"), value: 'not' }];
        },
        conditionModeOptions() {
            return [{ caption: this.$t('searchQuery.inRadius'), value: 'radius' }, { caption: this.$t('searchQuery.isEmpty'), value: 'empty' }];
        }
    },
    methods: {
        selectNegation(negValue) {
            this.negation = negValue;
            this.$emit('input', this.transformResult());
        },
        selectMode(mode) {
            if (mode !== 'radius') {
                this.pointValue.latitude = '';
                this.pointValue.longtitude = '';
                this.pointValue.radiusValue = 0;
            }

            this.conditionMode = mode;
            this.$emit('input', this.transformResult());
        },
        handleInput() {
            this.$emit('input', this.transformResult());
        },
        transformResult() {
            if (this.pointValue.latitude && this.pointValue.longtitude && this.pointValue.radiusValue >= 0) {
                return {
                    type: 'geo_point',
                    operator: this.conditionMode,
                    value: this.pointValue.latitude + ';' + this.pointValue.longtitude + ';' + this.pointValue.radiusValue,
                    negation: this.negation === 'not'
                };
            } else if (this.conditionMode == 'empty') {
                return {
                    type: 'geo_point',
                    operator: this.conditionMode,
                    value: '',
                    negation: this.negation === 'not'
                };
            } else {
                return undefined;
            }
        }
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                if (newVal != undefined && newVal.value != undefined && newVal.value != '') {
                    let splitValue = newVal.value.split(';');
                    this.pointValue.latitude = splitValue[0];
                    this.pointValue.longtitude = splitValue[1];
                    this.radiusValue = splitValue[2];
                    this.conditionMode = newVal.operator;
                    this.negation = newVal.negation || newVal.negation == 'not' ? 'not' : '';
                } else {
                    this.radiusValue = 0;
                    this.negation = '';
                }
                //
            },
            immediate: true,
            deep: true
        },
        pointValue: {
            handler(newVal, oldVal) {
                this.$emit('input', this.transformResult());
            }
        }
    }
};
</script>

<style scoped>
.input-container {
    display: flex;
    flex-flow: row;
    white-space: nowrap;
    border-bottom: 1px solid var(--input-border-color);
    background-color: var(--input-background-color);
}

.input-component {
    background-color: transparent;
    border: none;
    color: var(--input-font-color);
    padding: 5px 10px 5px 10px;
    outline: none;
    width: 25%;
    font-family: Source Sans Pro;
}

.active {
    color: var(--input-active-font-color);
    background-color: var(--input-active-background-color);
    border: 1px solid var(--input-active-border-color);
}

.required {
    color: var(--accent-color);
}

.inline-text {
    display: flex;
    padding: 0px 5px 0px 5px;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;
}
</style>
